import React from 'react'
import { Card, CardBody, Col, Row } from "reactstrap";


// component
import WlCardHeader from "../components/WlCardHeader";
import WlCardComment from "../components/WlCardComment";
import WishlistButtons from "../tools/WishlistButtons";

// label
import { LB_DATE, LB_HOUR  } from "../../i18n/i18n";

//utils
import { getWishlistOption, wishlistTypes } from "../../../util/WishlistUtils";

const ActivityViewComponent = props => {
    const option = getWishlistOption( wishlistTypes?.activity )

    return <Card className={'wl-card'}>
        <CardBody className={'wl-card-content'}>
            <WlCardHeader
                icon={ option?.icon }
                title={ option?.title }
                subTitle={props?.component?.title}
                pax={props?.component?.pax}
            />

            <div className={'wl-card-body ptb-1em mb-1em'}>
                <Row>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_DATE}</label> &nbsp;
                            <label className={'wl-label-value'}> {props?.component?.date}</label>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_HOUR}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.hour}</label>
                        </div>
                    </Col>
                </Row>
            </div>

            <WlCardComment comment={props?.component?.comments}/>

            <WishlistButtons from={'wishlist'} {...props} />
        </CardBody>
    </Card>
}

export default ActivityViewComponent